// extracted by mini-css-extract-plugin
module.exports = {"card":"AnalyticsCard_card__27EfZ","content":"AnalyticsCard_content__3QQ6f","earnings":"AnalyticsCard_earnings__2mVO4","whiteCircle":"AnalyticsCard_whiteCircle__3dX14"};